/* eslint-disable */
import 'regenerator-runtime/runtime.js'; // FormData uses Generators unfortunately
import './../libs/patched-formdata-polyfill/FormData.js';



// WEBPACK FOOTER //
// ./src/widgets/formdata-polyfill.js